import React from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, element, eventListener, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { CollapseEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { useSharedState } from '@philips-internal/oswald-ui-engine';
import { classNames, getLostProps, getSlot, isFunction, propagateProps } from '@philips-internal/oswald-ui-utils';
import { CollapseArrow } from '../collapse-arrow/collapse-arrow.js';
import { ExpanderAPI } from './expander-api.js';
import { ExpanderSlots } from './expander-constants.js';
import './expander.css';
const ContentContainer = {
    name: ExpanderSlots.CONTENT,
};
const ExpandableContentContainer = {
    name: ExpanderSlots.EXPANDABLE_CONTENT,
};
const awesomeProps = {
    api: ExpanderAPI,
    containers: [ContentContainer, ExpandableContentContainer],
    type: ComponentType.BEHAVIOR,
};
function Expander(props) {
    const [expanded, setExpanded] = useSharedState({
        initialValue: Boolean(props.initiallyExpanded),
        name: 'expanded',
        props,
    });
    const lostProps = getLostProps(Expander.propTypes, props);
    const childrenWithProps = propagateProps(props.children, { ...lostProps });
    const content = getSlot(childrenWithProps, ExpanderSlots.CONTENT);
    const expandedContent = expanded ? getSlot(childrenWithProps, ExpanderSlots.EXPANDABLE_CONTENT) : null;
    const className = classNames({
        'c-expander': true,
        [`${props.className}`]: Boolean(props.className),
    });
    const onExpand = (event) => {
        event.stopPropagation();
        event.preventDefault();
        setExpanded(previousExpanded => {
            const newExpanded = !previousExpanded;
            if (isFunction(props.onCollapse)) {
                props.onCollapse(new CollapseEvent({ collapsed: !newExpanded }));
            }
            return newExpanded;
        });
    };
    return (React.createElement("div", { className: className },
        React.createElement(Container, { className: "c-expander__content", slot: ContentContainer.name, uuid: props.uuid },
            content,
            props.arrowVisible
                ? React.createElement(CollapseArrow, { collapsed: !expanded, onClick: onExpand })
                : null),
        React.createElement(Container, { className: "c-expander__expandable-content", slot: ExpandableContentContainer.name, uuid: props.uuid }, expandedContent)));
}
Expander.propTypes = {
    arrowVisible: bool,
    children: oneOfType([element, arrayOf(element)]),
    className: string,
    initiallyExpanded: bool,
    onCollapse: eventListener,
    uuid: string,
};
Expander.defaultProps = {
    arrowVisible: true,
    uuid: '',
};
AwesomeComponent(awesomeProps)(Expander);
export { Expander, };
//# sourceMappingURL=expander.js.map